import React from 'react'
import ImagesPallet from '../../../../utils/ImagesPallet';

function ServicePremiumSection() {
  return ( 
   <div 
      className="min-h-screen bg-fixed bg-center bg-cover bg-no-repeat relative"
      style={{
        backgroundImage: "url('" + ImagesPallet.HeroSectionAbout2 + "')",
      }}
    >
      {/* Overlay gelap opsional untuk membuat konten lebih mudah dibaca */}
       <div className="absolute inset-0 bg-black/70">
        <h1></h1>
       </div>
      
       <div className="relative z-10 container mx-auto px-4 ">
         {/* konten section Anda */}
         
       </div>
    </div>
  )
}

export default ServicePremiumSection